import { useEffect, useState } from "react";

export default function useDarkMode() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [currentTheme, setCurrentTheme] = useState(() =>{
    if(typeof window !== "undefined") {
      const savedThemeStr = localStorage.getItem('colorTheme');
      if(savedThemeStr) {
        const savedTheme = JSON.parse(savedThemeStr);
        return savedTheme;
      } else {
        return "yellow";
      }
    }
    return "yellow";
  });


  useEffect(()=>{
    if(typeof window !== "undefined") {
      const savedThemeStr = localStorage.getItem('colorTheme');
      if(savedThemeStr) {
        const savedTheme = JSON.parse(savedThemeStr);
        setCurrentTheme(savedTheme);
      }
    }
  },[])

  function setTheme(selectedTheme){
    setCurrentTheme(selectedTheme);
  }

  useEffect(() => {
    const isDark = document.documentElement.classList.contains("dark");
    setIsDarkMode(isDark);

    const observer = new MutationObserver(() => {
      setIsDarkMode(
        document.documentElement.classList.contains("dark")
      );
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
  const themes = ["yellow", "dark"];

  document.documentElement.classList.remove(...themes);
  document.documentElement.classList.add(currentTheme);

  if (typeof window !== "undefined") {
    localStorage.setItem("colorTheme", JSON.stringify(currentTheme));
  }
}, [currentTheme]);


  return { isDarkMode, currentTheme, setTheme };
}
